import React, { useEffect, useState } from "react";
import { Header, Form, Grid, Button } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { renderTextField, renderOptionField } from "../formcomponents";
import { reduxForm, Field } from "redux-form";
import { userData } from "../store/userData";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
const CreateTour = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const { id } = useParams();
  const userDetail = userData();
  const navigate = useNavigate();
  const [buttonDisable, setbuttonDisable] = useState(false);
  useEffect(() => {
    if (id != "null") {
      getTourList();
    }
    if (userDetail.userRole != 1 && id != "null") {
      setbuttonDisable(true);
    }
    getEmployeeList();
    getVechileList();
  }, [id]);

  const [driverList, setdriverList] = useState([]);
  const [carList, setcarList] = useState([]);

  const getTourList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listTour", { ssTourId: 1 })
      .then((res) => {
        console.log(res.data);
        const tempData = res.data.find((item) => item.ssTourId == id);
        console.log("tempData", tempData);
        initializeData(tempData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeData = (data) => {
    props.initialize({
      ssTourId: data.ssTourId,
      tourDriverId: data.tourDriverId,
      tourVehicleId: data.tourVehicleId,
      tourName: data.tourName,
      tourDescription: data.tourDescription,
      startDate: data.startDate,
      endDate: data.endDate,
      startingKms: data.startingKms,
      endingKms: data.endingKms,
      customerName: data.customerName,
      customerNumber: data.customerNumber,
      pickupLocation: data.pickupLocation,
    });
  };

  const getEmployeeList = async () => {
    await axios
      .get(BaseUrl + "getBackOfficeUserList")
      .then((res) => {
        console.log(res.data);
        const tempData = res.data;
        const filterItem = tempData.filter((item) => item.userRole == 6);
        console.log("filterItem", filterItem);
        let tempArr = [];
        for (let i = 0; i < filterItem.length; i++) {
          tempArr.push({
            text: filterItem[i].userFirstName + filterItem[i].userLastName,
            value: filterItem[i].userId,
          });
        }
        setdriverList(tempArr);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getVechileList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listVehicle", { vehicleId: 1 })
      .then((res) => {
        console.log(res.data);

        const filterItem = res.data;
        let tempArr = [];
        for (let i = 0; i < filterItem.length; i++) {
          tempArr.push({
            text: filterItem[i].vehicleBrand + "-" + filterItem[i].model,
            value: filterItem[i].vehicleId,
          });
        }
        setcarList(tempArr);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const sumbitForm = (values) => {
    axios
      .post(BaseUrlInvoice + "accounts/createTour", values)
      .then((res) => {
        console.log(JSON.stringify(res.data, null, 2));
        if (res.data.errCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Header dividing size="huge" as="h1">
        {id != "null" ? "Update" : "Create"} Tour
      </Header>
      <br />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            {/* <Field
                name="srNumber"
                label="SR Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField} 
              /> */}

            <Grid.Column>
              <Field
                name="tourDriverId"
                label="Driver Id"
                options={driverList}
                component={renderOptionField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="tourVehicleId"
                label="Vehicle Id"
                options={carList}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="tourName"
                label="Tour Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="tourDescription"
                label="Description"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="startDate"
                label="Start Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="endDate"
                label="End Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="startingKms"
                label="Starting Kms"
                type="number"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="endingKms"
                label="Ending Kms"
                type="number"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {/* <Field
                name="invoice"
                label="Invoice"
                type="text"
                component={renderTextField}
              /> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="customerName"
                label="Customer Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="customerNumber"
                label="Customer Number"
                type="number"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="pickupLocation"
                label="Pickup Location"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <br />
      <Button
        floated="right"
        positive
        disabled={submitting || buttonDisable}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>{" "}
    </div>
  );
};

export default reduxForm({
  form: "CreateTour",
})(CreateTour);
